module.exports = __webpack_public_path__ + "img/Bathroom.9c5db15f.jpg";